import { WIDGET_PREVIEW_IMAGES } from '@constants/widgetImages';

export const getWidgetPreviewImg = widgetName => {
    if (!widgetName) return '';

    return WIDGET_PREVIEW_IMAGES[widgetName.toUpperCase()] || '';
};
